

export default (state = [], action) => {
  if (action.type == "SET_SOUCCOT2") {
    return action.value;
  }
  return state;
};